module.exports = __webpack_public_path__ + "static/media/placeholder-tour.a7b299b5.jpg";